import React, { Component } from 'react';
import { connect } from 'react-redux';
import { EventPageTemplate, EventSettingsForm } from '../';
import { FramesActions, CoverActions } from '../../../actions';
import { Box, BoxSide } from '../../PageTemplate';
import { Update } from '../../Form';
import { Print, Upload } from './frame';
import { Name, Date, Limit, Close } from './event';
import { ValidateDate } from '../../../helper';
import { UploadCover } from './cover';

import './eventSettingsPage.scss';

class EventSettingsPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            eventID: null,
            eventFinised: false,
            isDemo: false
        }
    }

    static getDerivedStateFromProps(props, state) {
        const eventID = props.events.currentEventID;
        let eventFinised = false;
        let eventStarted = false;
        let isDemo = false;

        if(props.events.list && props.events.list[eventID]){
            const event = props.events.list[eventID];
            eventFinised = ValidateDate.itsPast(event.date.end, event.date.timeZone);
            eventStarted = ValidateDate.isSameOrBeforeNow(event.date.start, event.date.timeZone);
            isDemo = event.demo;
        }

        // get frame data here to prevent multiple calls in each child box
        if(eventID && eventID !== state.eventID) {
            props.dispatch(FramesActions.getAllFrames(eventID));
            props.dispatch(CoverActions.getCover(eventID));
        }

        return {
            eventID: eventID,
            eventFinised: eventFinised,
            eventStarted: eventStarted,
            isDemo: isDemo
        }
    }

    render() {
        const {eventFinised, eventStarted, isDemo} = this.state;
        const {uploadFrameProcess, updateFrameProcess, deleteFrameProcess} = this.props.frames;
        const {uploadCoverProcess, updateCoverProcess, deleteCoverProcess} = this.props.cover;
        const {updateEventProcess} = this.props.events;

        return (
            <EventPageTemplate id="eventSettingsPage">
                <Box className={`${!isDemo ? 'hide' : 'demoWarn'}`}>
                    אירוע לדוגמא
                </Box>
                <BoxSide>
                    <Name eventFinised={eventFinised}/>
                    <Date eventFinised={eventFinised} eventStarted={eventStarted}/>
                    <Limit eventFinised={eventFinised}/>
                    {/* <Box col="1">
                        <EventSettingsForm/>
                    </Box> */}
                </BoxSide>
                <BoxSide>
                    <Close eventFinised={eventFinised} eventStarted={eventStarted}/> 
                    <Upload eventFinised={eventFinised}/>
                    <Print eventFinised={eventFinised}/>
                    <UploadCover eventFinised={eventFinised}/>
                </BoxSide>
                <Update process={uploadFrameProcess || updateFrameProcess || deleteFrameProcess || updateEventProcess || uploadCoverProcess || updateCoverProcess || deleteCoverProcess}/>
            </EventPageTemplate>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        events: state.eventsReducer,
        frames: state.framesReducer,
        cover: state.coverReducer
    }
}

const EventSettingsPageWithRedux = connect(mapStateToProps)(EventSettingsPage);

export {EventSettingsPageWithRedux as EventSettingsPage};


// WEBPACK FOOTER //
// ./src/components/EventPage/settings/EventSettingsPage.jsx